var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "base-modal",
        { attrs: { id: "get-started-modal" } },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "header" }, [
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    attrs: { "aria-label": "Close" },
                    on: { click: _vm.close },
                  },
                  [
                    _c("img", {
                      attrs: {
                        alt: "close icon",
                        src: "/images/common/modal/Exit_Dusk.svg",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-contents-container" }, [
                _c("button", [_vm._v("I'm an educator")]),
                _vm._v(" "),
                _c("button", [_vm._v("I'm a parent")]),
                _vm._v(" "),
                _c("button", [_vm._v("I'm a student")]),
                _vm._v(" "),
                _c("button", [_vm._v("I'm an individual")]),
              ]),
            ]),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }